<template>
  <div v-loading="loading" class="base-card-info account-applyed">
    <div class="info-card-title">
      资料审核
    </div>

    <div class="aa-content" :style="`visibility: ${loading? 'hidden' : 'unset'}`">
      <div style="padding-top: 36px;">
        <svg-icon v-if="approvalSuccess" icon="charm:circle-tick" />
        <svg-icon v-else-if="approvalFailed" style="color: #F56C6C !important" icon="material-symbols:cancel-outline-rounded" />
        <svg-icon v-else style="color: #E6A23C !important" icon="majesticons:clock-line" />
      </div>

      <div class="aa-desc">
        <span v-if="statusTitle">{{ statusTitle }}</span>
        <div v-if="approvalFailed" style="padding-top: 8px;">
          <label>{{ statusSubTitle }}</label>
        </div>
      </div>

      <div>
        <el-button @click="emit('go-back')">
          返回
        </el-button>
        <el-button v-if="approvalSuccess && showPrevStep" type="primary" @click="emit('to-next')">
          下一步
        </el-button>
        <el-button v-if="approvalFailed" type="primary" @click="emit('re-apply')">
          重新申请
        </el-button>
        <!-- <el-button v-if="agrementSining" type="primary" @click="doSign">
          去签署
        </el-button> -->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useYibaoApplyStatus } from '../../composables/useYibaoApplyStatus';
import { SvgIcon } from '@vue3/components';
import { type IYibaoDetail } from '../../../types';
import { PropType, ref, toRaw, watch } from 'vue';

const emit = defineEmits(['go-back', 'to-next', 're-apply']);

defineOptions({ naem: 'AccountApplySuccess' });

const props = defineProps({
  showPrevStep: {
    type: Boolean,
    default: false,
  },
  bankInfo: {
    type: Object as PropType<any>,
    default() {
      return {};
    },
  },
});

const loading = ref(true);
const info = ref({} as IYibaoDetail);

const {
  statusTitle,
  statusSubTitle,
  approvalSuccess,
  approvalFailed,
} = useYibaoApplyStatus(info);

// function doSign() {
//   window.open(info.value.agreementSignUrl, '_blank');
// }

watch(
  () => props.bankInfo,
  (v) => {
    if (Object.keys(v).length > 0) {
      loading.value = false;
      info.value = toRaw(v);
    } else {
      loading.value = true;
    }
  },
  { immediate: true },
);
</script>

<style lang="scss" scoped>
.account-applyed {
  height: 100%;
  overflow-y: auto;
}

.aa-content {
  height: calc(100% - 90px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .svg-icon {
    width: 68px !important;
    height: 68px !important;
    color: #67C23A !important;
  }

  .aa-desc {
    padding-top: 8px;
    padding-bottom: 22px;
    text-align: center;

    span {
      font-size: 16px;
      color: #344767;
      font-weight: 600;
    }

    label {
      font-size: 14px;
      color: #6B7891;
    }
  }
}
</style>
